import { Content, isFilled } from "@prismicio/client";
import { SliceComponentProps } from "@prismicio/react";
import { PrismicNextLink } from "@prismicio/next";
import { Graphics } from "@/components/graphics";

export type FileListProps = SliceComponentProps<Content.FileListSlice>;

const FileList = ({ slice }: FileListProps) => {
  const { files } = slice.primary;

  return (
    <section
      data-slice-type={slice.slice_type}
      className="border-primary-light my-5 border-l pl-4"
      data-slice-variation={slice.variation}
    >
      <ul className="space-y-3.5">
        {files.map(
          ({ file }, index) =>
            isFilled.linkToMedia(file) && (
              <li key={index}>
                <PrismicNextLink
                  target="_blank"
                  download
                  field={file}
                  className="flex w-fit flex-wrap items-center gap-3"
                >
                  <Graphics.flleIcon />
                  {file.text} - <mark className="text-primary-light bg-transparent">{file.name}</mark>
                </PrismicNextLink>
              </li>
            )
        )}
      </ul>
    </section>
  );
};

export default FileList;
